import { baseApiClient as api } from "../baseService";
export const addTagTypes = ["police_investigation"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      policeInvestigationList: build.query<
        PoliceInvestigationListApiResponse,
        PoliceInvestigationListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/police-investigation/`,
        }),
        providesTags: ["police_investigation"],
      }),
      policeInvestigationRetrieve: build.query<
        PoliceInvestigationRetrieveApiResponse,
        PoliceInvestigationRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/police-investigation/${queryArg.id}/`,
        }),
        providesTags: ["police_investigation"],
      }),
      policeInvestigationUpdate: build.mutation<
        PoliceInvestigationUpdateApiResponse,
        PoliceInvestigationUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/police-investigation/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.updateMatterInvestigation,
        }),
        invalidatesTags: ["police_investigation"],
      }),
      policeInvestigationPartialUpdate: build.mutation<
        PoliceInvestigationPartialUpdateApiResponse,
        PoliceInvestigationPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/police-investigation/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedUpdateMatterInvestigation,
        }),
        invalidatesTags: ["police_investigation"],
      }),
      policeInvestigationReconcileMultiple: build.mutation<
        PoliceInvestigationReconcileMultipleApiResponse,
        PoliceInvestigationReconcileMultipleApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/police-investigation/reconcile-multiple/`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["police_investigation"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as enhancedApi };
export type PoliceInvestigationListApiResponse =
  /** status 200  */ ReadMatterInvestigation[];
export type PoliceInvestigationListApiArg = {
  matterId: string;
};
export type PoliceInvestigationRetrieveApiResponse =
  /** status 200  */ ReadMatterInvestigation;
export type PoliceInvestigationRetrieveApiArg = {
  id: string;
  matterId: string;
};
export type PoliceInvestigationUpdateApiResponse =
  /** status 200  */ ReadMatterInvestigation;
export type PoliceInvestigationUpdateApiArg = {
  id: string;
  matterId: string;
  updateMatterInvestigation: UpdateMatterInvestigation;
};
export type PoliceInvestigationPartialUpdateApiResponse =
  /** status 200  */ ReadMatterInvestigation;
export type PoliceInvestigationPartialUpdateApiArg = {
  id: string;
  matterId: string;
  patchedUpdateMatterInvestigation: UpdateMatterInvestigation2;
};
export type PoliceInvestigationReconcileMultipleApiResponse =
  /** status 202  */ {
    processed?: number;
    failed?: number;
    results?: any;
    errors?: any;
  };
export type PoliceInvestigationReconcileMultipleApiArg = {
  matterId: string;
  body: Blob;
};
export type MatterInvestigationStatus =
  | "need_info"
  | "researching"
  | "investigating"
  | "escalated"
  | "completed_report_received"
  | "closed_no_report"
  | "not_applicable"
  | "backfilled_closed";
export type ReadMatterInvestigation = {
  /** Overall investigation status for the matter */
  status?: MatterInvestigationStatus;
  /** Free-form notes explaining the current status or transitions */
  description?: string | null;
  id: string | string;
  matter_id: string | string;
  created_at: string;
  modified_at: string;
};
export type UpdateMatterInvestigation = {
  /** Overall investigation status for the matter */
  status?: MatterInvestigationStatus;
  /** Free-form notes explaining the current status or transitions */
  description?: string | null;
  id: string | string;
};
export type UpdateMatterInvestigation2 = {
  /** Overall investigation status for the matter */
  status?: MatterInvestigationStatus;
  /** Free-form notes explaining the current status or transitions */
  description?: string | null;
  id: string | string;
};
export const {
  usePoliceInvestigationListQuery,
  usePoliceInvestigationRetrieveQuery,
  usePoliceInvestigationUpdateMutation,
  usePoliceInvestigationPartialUpdateMutation,
  usePoliceInvestigationReconcileMultipleMutation,
} = injectedRtkApi;
